function initFaq() {
	const faqQuestions = document.querySelectorAll('.faq-question');

	faqQuestions.forEach(function (question) {
		question.addEventListener('click', function (e) {
			e.preventDefault();

			const faqItem = this.closest('.faq-item');
			const content = faqItem.querySelector('.faq-answer');

			// Використовуємо jQuery тільки для slideToggle
			jQuery(content).slideToggle(300);
			faqItem.classList.toggle('is-active');
		});
	});
}

initFaq();
function initHeaderMenu() {
	const headerMenuLinks = document.querySelectorAll('.header-menu-link--dropdown');
	const allSubmenus = document.querySelectorAll('.header-submenu');

	headerMenuLinks.forEach(link => {
		const menuItem = link.closest('.header-menu-item');
		const currentSubmenu = menuItem.querySelector('.header-submenu');
		link.addEventListener('click', (e) => {
			e.preventDefault();


			// Закриваємо всі інші підменю
			allSubmenus.forEach(submenu => {
				if (submenu !== currentSubmenu) {
					jQuery(submenu).slideUp(300);
					submenu.classList.remove('active');
				}
			});

			// Перемикаємо поточне підменю
			if (currentSubmenu) {
				jQuery(currentSubmenu).slideToggle(300);
				menuItem.classList.toggle('is-active');
			}
		});
	});

	// Закриваємо підменю при кліку поза ним
	document.addEventListener('click', (e) => {
		if (!e.target.closest('.header-menu-item')) {
			const allSubmenus = document.querySelectorAll('.header-submenu');
			allSubmenus.forEach(submenu => {
				jQuery(submenu).slideUp(300);
				submenu.classList.remove('active');
			});
			document.querySelectorAll('.header-menu-item').forEach(item => {
				item.classList.remove('is-active');
			});
		}
	});
}

// function initHeaderMenuMobile() {
// 	const headerBurger = document.querySelector('.header-burger');
// 	const headerMenuClose = document.querySelector('.header-menu-close');
// 	const headerMenu = document.querySelector('.header-menu');

// 	headerBurger.addEventListener('click', () => {
// 		headerMenu.classList.toggle('is-active');
// 	});

// 	headerMenuClose.addEventListener('click', () => {
// 		headerMenu.classList.remove('is-active');
// 	});
// }

initHeaderMenu();
// initHeaderMenuMobile();

// Глобальна змінна для екземпляра Swiper
let reviewsSwiperInstance = null;
let savedSwiperPosition = null;

function initreviewsSlider() {
	const reviewsSwiper = document.querySelector('.reviews-slider');
	const reviewsSwiperItems = document.querySelectorAll('.reviews-item');
	const reviewsBtnPrev = document.querySelector('.reviews-nav .btn-arrow--prev');
	const reviewsBtnNext = document.querySelector('.reviews-nav .btn-arrow--next');

	if (!reviewsSwiper) return;

	reviewsSwiperInstance = new Swiper(reviewsSwiper, {
		slidesPerView: 'auto',
		spaceBetween: 9,
		loop: true,
		centeredSlides: true,
		navigation: {
			prevEl: reviewsBtnPrev,
			nextEl: reviewsBtnNext,
		},
		pagination: {
			el: '.reviews-nav .swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 24,
				loop: false,
				centeredSlides: false,
			},
		},
	});

	reviewsSwiperItems.forEach(function (item) {
		item.addEventListener('click', function () {
			savedSwiperPosition = reviewsSwiperInstance.translate;
			reviewsSwiperInstance.disable();
		});
	});
}

// Ініціалізація Fancybox для галереї сертифікатів
function initreviewsGallery() {
	if (typeof Fancybox === 'undefined') return;

	Fancybox.bind("[data-fancybox='video']", {
		Toolbar: {
			display: {
				left: ["infobar"],
				middle: [],
				right: ["slideshow", "thumbs", "close"],
			},
		},
		Thumbs: {
			autoStart: true,
		},
		showClass: "f-fadeIn",
		hideClass: "f-fadeOut",
		fitToView: true,
		autoFocus: false,
		keyboard: {
			Escape: "close",
			Delete: "close",
			Backspace: "close",
			PageUp: "next",
			PageDown: "prev",
			ArrowRight: "next",
			ArrowLeft: "prev",
			ArrowUp: "prev",
			ArrowDown: "next",
			Space: "play",
		},
		on: {

			destroy: () => {
				setTimeout(() => {
					reviewsSwiperInstance.enable();
					reviewsSwiperInstance.setTranslate(savedSwiperPosition);
					reviewsSwiperInstance.updateActiveIndex();
				}, 50);
			}
		}
	});
}


const testimonials = document.querySelector('.testimonials');

// if (testimonialsSlider) {
// 	new Swiper(testimonialsSlider, {
// 		slidesPerView: 2,
// 		spaceBetween: 12,
// 		loop: true,
// 		navigation: {
// 			nextEl: testimonialsNav.querySelector('.btn-arrow--next'),
// 			prevEl: testimonialsNav.querySelector('.btn-arrow--prev'),
// 		},
// 		breakpoints: {
// 			525: {
// 				slidesPerView: 'auto',
// 				spaceBetween: 24,
// 			},
// 		},
// 	});
// }


if (testimonials) {
	const testimonialsSlider = testimonials.querySelector('.testimonials-slider');
	const testimonialsNav = testimonials.querySelector('.testimonials-nav');

	if (testimonialsSlider && testimonialsNav) {
		new Swiper(testimonialsSlider, {
			slidesPerView: 2,
			spaceBetween: 12,
			loop: true,
			navigation: {
				nextEl: testimonialsNav.querySelector('.btn-arrow--next'),
				prevEl: testimonialsNav.querySelector('.btn-arrow--prev'),
			},
			breakpoints: {
				525: {
					slidesPerView: 'auto',
					spaceBetween: 24,
				},
			},
		});
	}
}